import {$type} from "../utils/di-container.js";

export class JournalService {

  _journal = [];

  write(type, obj) {
    const journalItem = { ts: Date.now(), type, obj };
    this._journal.push(journalItem);
    document.dispatchEvent(new CustomEvent('authorizedby_badge_journal_write', { detail: journalItem }));
  }

}

JournalService[$type] = Symbol('JournalService');
